import { Injectable } from '@angular/core';
import { ApiRestService, BaseSiteRestService } from '@motivforce/mx-library-angular';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ContactUs } from '../../model/contact-us';

@Injectable({
  providedIn: 'root',
})
export class SupportRestService extends BaseSiteRestService {
  constructor(protected apiRestService: ApiRestService) {
    super(environment.api.core.baseUrl, environment.api.core.path.member, 'lenovo/leap/support');
  }

  contactUs(contactRequest: ContactUs): Observable<any> {
    return this.apiRestService.post<any>(`${this.memberBaseUrl}/contactus`, contactRequest);
  }

  getSubjects(): Observable<string[]> {
    return this.apiRestService.get<string[]>(`${this.memberBaseUrl}/subject-options`);
  }

  sendSupportRequest(endpoint: any, data: any): Observable<any> {
    return this.apiRestService.post<any>(`${this.memberBaseUrl}/${endpoint}`, data);
  }

  getBusinessGroups(): Observable<string[]> {
    return this.apiRestService.get<string[]>(
      `${environment.api.core.baseUrl}/clients/lenovo/leap/companydetails/business-groups`
    );
  }
}
